import baseline from './baseline';
import is2645CitMitV1Test from './2645-cit-mit-v1-test';

export default {
  '2645-cit-mit-v1-test': is2645CitMitV1Test,
  baseline
};
